import { Label } from 'framework/label';

import { FieldFormProps } from '../types';

export const FieldWrapper = ({
  label = '',
  information = '',
  width = '100%',
  padding = '0px',
  theme,
  children,
}: FieldFormProps) => {
  return (
    <div style={{ width, padding }}>
      <Label label={label} information={information} padding="0px 0px 4px 0px" theme={theme} />
      {children}
    </div>
  );
};
